import 'bootstrap/dist/css/bootstrap.min.css';
import "@/styles/globals.css";
import "@/styles/custom.css"
import "@/styles/responsive.css"
import { useEffect } from "react";
import Layout from "@/components/layout";
// import { DefaultSeo } from "next-seo";
import { AnimatePresence, m } from "framer-motion";
import { LazyMotion, domAnimation } from "framer-motion";
import GraphqlProvider from "@/lib/provider";
import Head from "next/head";
import { ManagedUIContext } from "@/contexts/ui.context";
import { GoogleAnalytics } from "@next/third-parties/google";
import { useRouter } from "next/router";
import Script from "next/script";
import * as fbq from "../lib/fpixel";

export default function App({ Component, pageProps, router }) {
  const noLayout = router.pathname === "/3d-portfolio";
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (!sessionStorage.getItem("source_url")) {
        sessionStorage.setItem("source_url", window.location.href);
      }
    }
  }, []);
  // useEffect(() => {
  //   import('bootstrap/dist/js/bootstrap.bundle.min.js');
  // }, []);


  // useEffect(() => {
  //   // adding script
  //   const timer = setTimeout(() => {
  //     const script = document.createElement("script");
  //     script.type = "text/javascript";
  //     script.defer = true;
  //     script.id = "messenger-widget-b";
  //     script.src = "https://cdn.botpenguin.com/website-bot.js";
  //     script.textContent = "62358a6a7911434dce72b517,62358a2b4c3c244dddeb7e04";
  //     document.body.appendChild(script);
  //   }, 5000);
  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, []);

  useEffect(() => {
    let hasScrolled = false;
    const handleScroll = () => {
      if (!hasScrolled) {
        hasScrolled = true;
        // Adding the script immediately on scroll
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.defer = true;
        script.id = "messenger-widget-b";
        script.src = "https://cdn.botpenguin.com/website-bot.js";
        script.textContent = "62358a6a7911434dce72b517,62358a2b4c3c244dddeb7e04";
        document.body.appendChild(script);
      }
    };
    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);
    // Cleanup scroll event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  // google tag


  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Chalk Studio",
    url: "https://www.chalkstudio.design/",
    logo: "",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "9599121499",
      contactType: "sales",
      areaServed: "IN",
      availableLanguage: ["en", "Hindi"],
    },
    sameAs: [
      "https://www.facebook.com/chalkstudiodesign/",
      "https://www.instagram.com/chalkstudio.design/",
      "https://www.linkedin.com/company/chalkstudio-design/",
    ],
  };

  const routerEl = useRouter();
  useEffect(() => {
    fbq.pageview();
    const handleRouteChange = () => {
      fbq.pageview();
    };
    routerEl.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      routerEl.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [routerEl.events]);


  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.ico" type="image/x-icon" sizes="any" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" sizes="76x76" />
      </Head>
      <AnimatePresence mode="wait">
        {/* <SingleModalProvider> */}
        {/* <Partytown debug={true} forward={["dataLayer.push"]} /> */}
        <GraphqlProvider>
          <LazyMotion features={domAnimation}>
            <ManagedUIContext>
              <Head>
                <script defer type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd), }} />
              </Head>
              {/* <DefaultSeo
                title="Interior Designing Firm | Interior Design Studio"
                defaultTitle="Interior Designing Firm | Interior Design Studio"
                description="Chalk Studio, an interior designing firm provides customized interior design solutions for residential & commercial spaces."
                canonical="https://www.chalkstudio.design"
                openGraph={{
                  url: "https://www.chalkstudio.design",
                  title: "Interior Designing Firm | Interior Design Studio",
                  description:
                    "Chalk Studio, an interior designing firm provides customized interior design solutions for residential & commercial spaces.",
                  images: [
                    {
                      url: "/logo.png",
                      width: 140,
                      height: 140,
                      alt: "Chalk Studio",
                    },
                  ],
                }}
                twitter={{
                  // handle: "@avneesh0612",
                  // site: "@avneesh0612",
                  cardType: "summary_large_image",
                }}
                additionalLinkTags={[
                  {
                    rel: "icon",
                    href: `/favicon.svg`,
                  },
                  {
                    rel: "apple-touch-icon",
                    href: "/favicon.svg",
                    sizes: "76x76",
                  },
                  {
                    name: "facebook-domain-verification",
                    content: "cna82514n469zcietw3tz3xafqzfjq",
                  },
                  {
                    name: "google-site-verification",
                    content: "wEztn_NdzXWcXTIvePHmSzPGEeRpQPuHSniA4xvfVzY",
                  },
                ]}
              /> */}
              {noLayout ? (
                <Component {...pageProps} key={router.route} />
              ) : (
                <Layout>
                  <GoogleAnalytics gaId="UA-195884263-1" />
                  <Script strategy="lazyOnload" id="fb-pixel"
                    dangerouslySetInnerHTML={{ __html: `!(function (f, b, e, v, n, t, s){ if (f.fbq)return;n= f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments);};if(!f._fbq)f._fbq = n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t, s);})(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");fbq("init", "1267638404111611");`, }}
                  />
                  <Component {...pageProps} key={router.route} />
                </Layout>
              )}
            </ManagedUIContext>
          </LazyMotion>
        </GraphqlProvider>
        {/* </SingleModalProvider> */}
      </AnimatePresence>
    </>
  );
}
